import React from "react";
import { HubContextMenu } from "../../components";
import { useDeleteWorkOrderTest } from "../../hooks";

const MENU_ITEMS = [
  {
    id: "delete",
    label: "Delete",
    icon: "Trash2",
    color: "redError",
  },
];

const WorkOrderTestingContextMenu = ({ item, ...rest }) => {
  const { mutate: deleteTest } = useDeleteWorkOrderTest();
  const onSelect = (selected) => {
    switch (selected?.id) {
      case "delete":
        deleteTest(item?.id);
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id="test"
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: 0 } }}
      HubIconProps={{ size: 14 }}
      {...rest}
    />
  );
};
export default WorkOrderTestingContextMenu;
